// source/apps/cms/src/plugins/vuetify.ts
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
export const vuetify = createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: 'light',
        themes: {
            light: {
                dark: false,
                colors: {
                    primary: '#00abbb',
                    'primary-darken-1': '#009287',
                    secondary: '#286bab',
                    accent: '#00bead',
                    error: '#b91c1c',
                    info: '#286bab',
                    success: '#15803d',
                    warning: '#b45309',
                    background: '#f2f9f9',
                    surface: '#ffffff',
                },
                variables: {
                    'border-color': '#e3e8ee',
                    'border-opacity': 1,
                },
            },
        },
    },
    defaults: {
        global: {
            ripple: true,
        },
        VBtn: {
            rounded: 'lg',
            style: 'text-transform: none; letter-spacing: 0;',
            variant: 'flat',
        },
        VCard: {
            rounded: 'lg',
            elevation: 0,
            border: true,
        },
        VTextField: {
            variant: 'outlined',
            density: 'comfortable',
            rounded: 'lg',
            color: 'primary',
        },
        VSelect: {
            variant: 'outlined',
            density: 'comfortable',
            rounded: 'lg',
            color: 'primary',
        },
        VAutocomplete: {
            variant: 'outlined',
            density: 'comfortable',
            rounded: 'lg',
            color: 'primary',
        },
        VCombobox: {
            variant: 'outlined',
            density: 'comfortable',
            rounded: 'lg',
            color: 'primary',
        },
        VTextarea: {
            variant: 'outlined',
            density: 'comfortable',
            rounded: 'lg',
            color: 'primary',
        },
        VChip: {
            rounded: 'md',
        },
        VDataTable: {
            hover: true,
        },
        VList: {
            density: 'comfortable',
        },
    },
});
